import { isEmpty } from 'lodash';
import React from 'react';
import { useTaxonomyContext } from '../../../contexts/Taxonomy';
import parse from 'html-react-parser';

const ActiveFilter = ({ label, onRemove }) => {
    return (
        <span className="min-h-[30px] inline-flex items-center rounded-md bg-brand-secondary py-0.5 pl-2.5 pr-1 mr-1 text-xs leading-4 text-white">
            {parse(label)}
            <button
                type="button"
                className="ml-0.5 inline-flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full text-white  hover:text-brand-primary focus:bg-brand-primary focus:text-white focus:outline-none"
                onClick={onRemove}
            >
                <svg
                    className="h-2 w-2"
                    stroke="currentColor"
                    fill="none"
                    viewBox="0 0 8 8"
                >
                    <path
                        strokeLinecap="round"
                        strokeWidth="1.5"
                        d="M1 1l6 6m0-6L1 7"
                    />
                </svg>
            </button>
        </span>
    );
};
export default function ActiveFilters({ applyFilter }) {
    const taxonomyCtx = useTaxonomyContext();

    const [, , selectedPriceFilter, setPrice] = taxonomyCtx.priceFilter;
    const [, , selectedTypeFilter, setType] = taxonomyCtx.typeFilter;
    const [, , selectedFavouriteFilter, setFavourite] =
        taxonomyCtx.favouriteFilter;
    const [, , selectedOcasionFilter, setOcassion] = taxonomyCtx.ocassionFilter;
    const [, , selectedSuitableForFilter, setSuitableFor] =
        taxonomyCtx.suitableForFilter;

    return (
        <div className="text-center">
			{!isEmpty(selectedPriceFilter) && (
                <ActiveFilter
                    label={selectedPriceFilter.label}
                    onRemove={() => setPrice(null)}
                />
            )}

            {!isEmpty(selectedTypeFilter) && (
                <ActiveFilter
                    label={selectedTypeFilter.label}
                    onRemove={() => setType(null)}
                />
            )}
            {!isEmpty(selectedFavouriteFilter) && (
                <ActiveFilter
                    label={selectedFavouriteFilter.label}
                    onRemove={() => setFavourite(null)}
                />
            )}

            {!isEmpty(selectedOcasionFilter) && (
                <ActiveFilter
                    label={selectedOcasionFilter.label}
                    onRemove={() => setOcassion(null)}
                />
            )}

            {!isEmpty(selectedSuitableForFilter) && (
                <ActiveFilter
                    label={selectedSuitableForFilter.label}
                    onRemove={() => setSuitableFor(null)}
                />
            )}
        </div>
    );
}
